<template>
  <div>
    <figure class="mb-4">
      <img src="/img/site/amico.png" alt="" width="181" />
    </figure>
    <span class="font-xl font-weight-bold">
      {{ $t('empty.message.title') }}
    </span>
  </div>
</template>

<script>
export default {
  name: 'EmptyMessage',
}
</script>
